<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general } from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'GuardianChangedYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Has anything changed regarding the people you have appointed to be guardians for your minor children?',
        subTitle: 'Choosing who will raise your children if you pass away is one of the most important decisions in a Will. If your chosen guardians have moved away, divorced, suffered ill health, or if you simply feel someone else is now better suited for the role, an update is essential. Ensuring your named guardians are still willing and able to take on this responsibility gives you peace of mind.',
        tip: null,
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'guardianChangedYN',
        formPath: 'guardianChangedYN',
        jsonSaveField: 'guardianChangedYN',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
